// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueFire from 'vuefire';

// import 'onsenui/css/onsenui.css';
// import 'onsenui/css/onsen-css-components.css';
//
import 'spectre.css/dist/spectre.css'
import 'spectre.css/dist/spectre-exp.css'

// import 'onsenui';
// import VueOnsen from 'vue-onsenui';


import App from './App';
import router from './router';

// explicit installation required in module environments
Vue.use(VueFire);

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
});

// Prevent scaling
document.addEventListener('gesturestart', function (e) {
    e.preventDefault();
});



// WEBPACK FOOTER //
// ./src/main.js